export default __webpack_public_path__ + "static/media/Hair_3_M_C1.d4280ecb.svg";